import { useCallback, useRef } from "react";
import { useModalMotion } from "../hooks/useModalMotion";
import shopBurst from "../assets/img/shop-burst.png";

const COPY = {
  quit: {
    title: "LEAVE THE MERCHANDISE SHOP?",
    body: "YOUR SESSION WILL BE LOST IF YOU LEAVE THIS PAGE. ARE YOU SURE YOU WANT TO QUIT?",
    confirm: "QUIT",
  },
  back: {
    title: "GO BACK TO YOUR GALLERY?",
    body: "YOUR CART ITEMS WILL STAY SAVED. YOU CAN RETURN ANYTIME TO KEEP SHOPPING.",
    confirm: "GO BACK",
  },
};

function ShopLeaveModal({
  show,
  intent = "quit",
  onStay,
  onConfirm,
  title,
  copy,
  confirmLabel,
}) {
  const actionRef = useRef(null);
  const finish = useCallback(() => {
    const action = actionRef.current;
    actionRef.current = null;
    action?.();
  }, []);
  const { requestClose, motionClassName } = useModalMotion(finish, {
    open: show,
  });

  const runThenClose = (action) => {
    actionRef.current = action;
    requestClose();
  };

  if (!show) return null;

  const preset = COPY[intent] || COPY.quit;
  const heading = title || preset.title;
  const body = copy || preset.body;
  const confirm = confirmLabel || preset.confirm;

  return (
    <div
      className={`shopLeave${motionClassName}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="shopLeaveTitle"
    >
      <button
        type="button"
        className="shopLeave__backdrop"
        onClick={() => runThenClose(onStay)}
        aria-label="Stay and continue"
      />
      <div className="shopLeave__card">
        <div className="shopLeave__titleRow">
          <img
            className="shopLeave__burst shopLeave__burst--left"
            src={shopBurst}
            alt=""
            aria-hidden="true"
          />
          <h2 id="shopLeaveTitle" className="shopLeave__title">
            {heading}
          </h2>
          <img className="shopLeave__burst" src={shopBurst} alt="" aria-hidden="true" />
        </div>
        <p className="shopLeave__copy">{body}</p>
        <div className="shopLeave__actions">
          <button
            type="button"
            className="shopLeave__stay"
            onClick={() => runThenClose(onStay)}
          >
            STAY &amp; CONTINUE
          </button>
          <button
            type="button"
            className="shopLeave__quit"
            onClick={() => runThenClose(onConfirm)}
          >
            {confirm}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShopLeaveModal;
